export default function Log({gturn,playersname}){
    return <ol id="log">
        {gturn.map(turn => <li key={`${turn.square.row}${turn.square.col}`}>{playersname[turn.player]} selected {turn.square.row},{turn.square.col}</li>)}
    </ol>
}